 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import HALFTITLE from '@/components/Half-Title'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import PAGE04 from '@/components/Page04'
 import CONTENTS from '@/components/Contents'
 import FOREWORD from '@/components/Foreword'
 import WELCOME from '@/components/Welcome'
 import PART1 from '@/components/Part1'
 import CHAPTER01 from '@/components/Chapter01'
 import CHAPTER02 from '@/components/Chapter02'
 import CHAPTER03 from '@/components/Chapter03'
 import CHAPTER04 from '@/components/Chapter04'
 import CHAPTER05 from '@/components/Chapter05'
 import PART2 from '@/components/Part2'
 import CHAPTER06 from '@/components/Chapter06'
 import CHAPTER07 from '@/components/Chapter07'
 import CHAPTER08 from '@/components/Chapter08'
 import CHAPTER09 from '@/components/Chapter09'
 import CHAPTER10 from '@/components/Chapter10'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER12 from '@/components/Chapter12'
 import CHAPTER13 from '@/components/Chapter13'
 import CHAPTER14 from '@/components/Chapter14'
 import CHAPTER15 from '@/components/Chapter15'
 import CHAPTER16 from '@/components/Chapter16'
 import CHAPTER17 from '@/components/Chapter17'
 import CHAPTER18 from '@/components/Chapter18'
 import PART3 from '@/components/Part3'
 import CHAPTER19 from '@/components/Chapter19'
 import CHAPTER20 from '@/components/Chapter20'
 import CHAPTER21 from '@/components/Chapter21'
 import CHAPTER22 from '@/components/Chapter22'
 import PART4 from '@/components/Part4'
 import CHAPTER23 from '@/components/Chapter23'
 import CHAPTER24 from '@/components/Chapter24'
 import CHAPTER25 from '@/components/Chapter25'
 import A_GHOSTLY_GOODBYE from '@/components/A_Ghostly_Goodbye'
 import YOU_STILL_HAUNT from '@/components/You_Still_Haunt'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import AUTHOR from '@/components/Author'
 import BIBLIOGRAPHY from '@/components/Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Foreword",
 			"name" : "Foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/Welcome",
 			"name" : "Welcome",
 			"component" : WELCOME
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js